import { useCallback } from "react";
import { useProject } from "../context/ProjectContext.tsx";
import { useMechanicsConfiguration } from "../context/MechanicsConfigurationContext.tsx";
import { useElectronicsConfiguration } from "../context/ElectronicsConfigurationContext.tsx";
import { useTestProcedure } from "../context/TestProcedureContext.tsx";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useSoftwareDesignFiles = () => {
  const { handle, setError } = useMessageHandler();
  const { project } = useProject();
  const { config: mechanics } = useMechanicsConfiguration();
  const { config: electronics } = useElectronicsConfiguration();
  const { procedures } = useTestProcedure();

  const getSoftwareDesignFiles = useCallback(async () => {
    if (!mechanics || !electronics) {
      setError("Konfiguration ungültig.");
      return;
    } else if (!procedures?.length) {
      setError("Keine Prüfabläufe vorhanden.");
      return;
    }
    await handle(async () => {
      const payload = {
        project: project,
        mechanics: mechanics,
        electronics: electronics,
        procedures: procedures,
      };
      const response = await apiJson.post("/design_files/software", payload, {
        responseType: "blob",
      });
      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = new Date().toISOString().slice(0, 10).replace(/-/g, '') + "_qdTest_" + project.name + "_SoftwareDesignFiles.zip";
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }, [handle]);

  return { getSoftwareDesignFiles };
};

